export const CARD_RARITY = {
    COMMON: {
        color: '#808080',
        maxCopies: 2
    },
    UNCOMMON: {
        color: '#00ff00',
        maxCopies: 2
    },
    RARE: {
        color: '#0070dd',
        maxCopies: 2
    },
    EPIC: {
        color: '#a335ee',
        maxCopies: 2
    },
    LEGENDARY: {
        color: '#ff8000',
        maxCopies: 1
    }
};

export const DECK_RULES = {
    MAX_CARDS: 30,
    MIN_CARDS: 30
};
